import app from '../app';
import Page, { IPageAttrs } from '../../common/components/Page';
import NotificationList from '../components/NotificationList';
import type Mithril from 'mithril';
import extractText from '../../common/utils/extractText';
import NotificationListState from '../states/NotificationListState';
import avatar from '../../common/helpers/avatar';
import RoleBindingModal from '../dianLiang/RoleBindingModal';
import GiftPackModal from '../dianLiang/GiftPackModal';
import AlertUtil from '../../forum/dianLiang/alertUtil';
import RequestError from '../../common/utils/RequestError';

/**
 * The `LikesPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class MallPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  giftPackCheck: number = 0;
  inputValue: number = 0;
  payItem: number = 12;
  payNum: number = 0;
  localePkgName: string = '';
  chargeList = [];
  shopDiscount = 100;
  chargeName = ''; // 商品名称
  roleInfo = ''; // 角色信息
  chargeOriginal = '0'; // 商品原价
  chargeDiscount = '0'; // 商城折扣
  chargeAmount = '0'; // 合计
  payType = []; // 支付方式
  icon = ''; // 商品图标
  getChargeList = () => {
    let rid = app.data['currentRole']['rid'];
    let srvId = app.data['currentRole']['srvId'];
    // 获取商品列表
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + `/sdkChargeList?rid=${rid}&srvId=${srvId}`,
      })
      .then((res) => {
        if (res != null && res != undefined && res != []) {
          // 返回的数组[排序,id,名称,金额,描述,图片,限制,剩余限制,[奖品id,奖品数量,奖品icon,奖品名字]]
          this.chargeList = res.chargeList;

          this.shopDiscount = res.shopDiscount == 0 ? 100 : res.shopDiscount;
          this.chargeName = this.chargeList[0][2];
          if (this.chargeList[0][6] == 0) {
            this.payNum = 99;
          } else if (this.chargeList[0][7] > 0) {
            this.payNum = this.chargeList[0][7];
          }
          this.inputValue = this.payNum == 0 ? 0 : 1;
          this.onChange();
          this.payType = res.payType;
          m.redraw();
          if (this.payType[0] && this.payType[0].length > 0) {
            // 设置默认支付方式
            this.onClickPayItem(parseInt(this.payType[0]));
          }
        }
      });
  };
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    app.history.push('notifications', extractText(app.translator.trans('dl-person.forum.mall')));

    app.notifications = new NotificationListState({
      filter: { type: ['postMalled'] },
      // sort: 'newest',
    });

    let pkgLogo = app.data.pkgLogo;

    if (pkgLogo) {
      const obj = JSON.parse(pkgLogo.pkgName);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      this.localePkgName = map.get(app.data.locale);
    }

    app.notifications.load();
    // app.notifications.refreshParams(param);

    this.bodyClass = 'App--notifications';

    // 刚进入页面查一下角色列表
    if (app.session.user) {
      app
        .request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/sdkUserRole/' + app.session.user?.id(),
        })
        .then((res) => {
          app.data['roleInfo'] = res;
          Object.keys(res).forEach((element) => {
            // let roleInfo = { rid: element.rid, lev: element.lev, srvId: element.srvId, name: element.name, faceId: element.faceId, pkgId: element.pkgId, pkgName: element.pkgName };
            // app.data['roleInfo'].push(roleInfo);
            res[element].forEach((item) => {
              if (item.current) {
                app.data['currentRole'] = item;
              }
            });
          });
          // app.data['currentRole'] = app.data['currentRole'] ? app.data['currentRole'] : (app.data['roleInfo'].length > 0 ? app.data['roleInfo'][0] : null)
          this.getChargeList();
        });
    }
  }
  oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>): void {
    const imgUrls = [
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex-while.png`,
    ];
    imgUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }
  view() {
    return (
      <div className="Mall">
        <div className="Mall-title">{app.translator.trans('dl-pay.forum.user.official_mall')}</div>
        {this.MallUserInfo()}
        {app.data['currentRole'] ? (
          <>
            <div className="Mall-gift-pack-box">{this.MallGiftPack()}</div>
            {this.MallPayBox()}
          </>
        ) : (
          <div className="Mall-bind-role-tip">{app.translator.trans('dl-response.forum.mallPage.please_bind_role')}</div>
        )}
      </div>
    );
  }
  MallUserInfo() {
    let pkgLogo = app.data.pkgLogo;
    let localePkgName = '';
    let localePkgIcon = '';
    if (pkgLogo) {
      let obj2 = JSON.parse(pkgLogo.pkgName);
      // 创建 Map 对象并初始化
      let map2 = new Map(Object.entries(obj2));
      // 获取特定键的值
      localePkgName = map2.get(app.data.locale);
      let obj = JSON.parse(pkgLogo.pkgIcon);
      let map = new Map(Object.entries(obj));
      localePkgIcon = map.get(app.data.locale);
    }

    return (
      <div className="Mall-head">
        <div className="Mall-user-info">
          <div className="user-info">
            <div className="user-avatar">
              <img src={localePkgIcon} />
            </div>
            <div className="user-head-top">
              <div className="user-name">{localePkgName}</div>
              {/* <div className="user-tag">GLOBAL</div> */}
              {/* <div className="user-collection">
                收藏<img src="${app.data.pkgLogo.cdnUrl}/2024-05-29/1716952268-844773-icon-sc.png"></img>
              </div> */}
            </div>
          </div>
          {app.data['roleInfo'] ? (
            <div className="role-info" id="shop-role-info">
              <div className="role-avatar">
                <img
                  className="img"
                  src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/headicon/${
                    app.data['currentRole'] && app.data['currentRole'].faceId
                  }.png`}
                ></img>
              </div>
              <div className="role-detailed-info" onclick={() => app.modal.show(RoleBindingModal, { getChargeList: this.getChargeList })}>
                <div className="role-top">{app.data['currentRole'] && app.data['currentRole'].name}</div>
                <div className="role-bototm">
                  <div className="role-uid">
                    {app.translator.trans('dl-pay.forum.user.uID')}: {app.data['currentRole'] && app.data['currentRole'].rid}
                  </div>
                  <div className="role-district-server">
                    {app.translator.trans('dl-pay.forum.user.srvId', { srvId: app.data['currentRole'] && app.data['currentRole'].srvId })}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
  MallGiftPack() {
    return (
      <div className="Mall-gift-pack">
        <div className="Mall-gift-pack-title">{app.translator.trans('dl-pay.forum.gift.gift_pack_selection')}</div>
        <div className="gift-pack-box">
          {this.chargeList.map((item, index) => (
            <div
              className={`gift-pack-item${index === this.giftPackCheck ? ' item-check' : ''}`}
              onclick={() => {
                this.giftPackCheck = index;
                // item[6] 限购次数等于0 代表不限购
                if (item[6] == 0) {
                  this.payNum = 99;
                } else if (item[7] > 0) {
                  this.payNum = item[7];
                }
                this.inputValue = this.payNum == 0 ? 0 : 1;
                this.onChange();
              }}
            >
              <div className="item-discount" style={this.shopDiscount == 100 ? 'display:none' : ''}>
                - {100 - this.shopDiscount}<span>%</span>
              </div>
              <div className="item-img">
                <img src={item[5]} alt="" />
              </div>
              <div className="item-content">
                <div className="gift-pack-describe">
                  {/* {item[8].map((item, index) => (
                    <div className='gift-pack-describe-item'>
                      {index !== 0 && <span className="jia">+</span>}
                      <img src={`${app.data.pkgLogo.cdnUrl}/mall/zhoushu2dz1/icon/item/${item[2]}.png`} alt="" />
                      <span>{item[1]}</span>
                    </div>
                  ))} */}
                  <div className="gift-pack-describe-item">{item[2]}</div>
                </div>
                {/* <div className="gift-pack-name">{item[2]}</div> */}
                <div className="gift-pack-num" style={item[6] == 0 ? 'display:none' : ''}>
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-xg.png`} alt="" />
                  {item[6] == 0 ? '99' : item[7]}
                </div>
              </div>
              <div
                className="item-price"
                onclick={() =>
                  app.modal.show(GiftPackModal, {
                    name: item[2],
                    price: (item[3] * (this.shopDiscount / 100)).toFixed(2),
                    desc: item[4],
                    icon: item[5],
                    reward: item[8],
                    originalPrice: item[3],
                  })
                }
              >
                <div className="current-price">USD {(item[3] * (this.shopDiscount / 100)).toFixed(2)}</div>
                <div className="original-price" style={this.shopDiscount == 100 ? 'display:none' : ''}>
                  USD {item[3]}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="gift-pack-num" id="gift-pack-sum">
          <div className="gift-pack-num-title">{app.translator.trans('dl-pay.forum.gift.purchase_quantity')}</div>
          <div className="quantity-selection">
            <div
              className="symbol-icon"
              onclick={() => {
                if (this.inputValue >= 1) {
                  this.inputValue--;
                }
                this.onChange();
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-jian.png`}></img>
            </div>
            <div className="content">
              <input
                type="number"
                value={this.inputValue}
                oninput={(e) => {
                  this.inputValChange(e);
                  this.onChange();
                }}
              />
              <span>/ <span>{this.payNum}</span></span>
              {/* 商品数量上限 */}
            </div>
            <div
              className="symbol-icon"
              onclick={() => {
                if (this.inputValue < this.payNum) {
                  this.inputValue++;
                }
                this.onChange();
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-add.png`} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  inputValChange(e) {
    if (e.target.value.length > 1 && e.target.value.charAt(0) == '0') {
      this.inputValue = e.target.value.slice(1);
      return;
    }
    if (e.target.value >= 1 && e.target.value <= this.payNum) {
      this.inputValue = e.target.value;
    } else if (e.target.value > this.payNum) {
      this.inputValue = this.payNum;
    } else {
      this.inputValue = 0;
    }
  }

  /** 选项更新 */
  onChange() {
    let charge = this.chargeList[this.giftPackCheck];
    this.chargeName = charge[2];
    this.icon = charge[5];
    let srvArr = app.data['currentRole']['srvId'].split('_');
    this.roleInfo = app.data['currentRole']['name'] + '-' + srvArr[1];
    let chargeOriginal = charge[3] * this.inputValue;
    let chargeDiscount = (chargeOriginal * (100 - this.shopDiscount)) / 100;
    let chargeAmount = (chargeOriginal * this.shopDiscount) / 100;
    this.chargeOriginal = chargeOriginal.toFixed(2);
    this.chargeDiscount = chargeDiscount.toFixed(2);
    this.chargeAmount = chargeAmount.toFixed(2);
  }

  MallPayBox() {
    return (
      <div className="pay-box">
        <div className="pay-box-title">{app.translator.trans('dl-pay.forum.order.payment_method')}</div>
        <div className="pay-method-list">
          <div
            className={`pay-method-item pay-style-paypal${this.payItem === 12 ? ' pay-item-check' : ''}`}
            onclick={() => {
              this.onClickPayItem(12);
            }}
            style={`display: ${this.payType?.includes('12') ? 'display' : 'none'}`}
          >
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal.png`} alt="【图片】"></img>Paypal
          </div>
          <div
            className={`pay-method-item pay-style-payermax${this.payItem === 16 ? ' pay-item-check' : ''}`}
            onclick={() => {
              this.onClickPayItem(16);
            }}
            style={`display: ${this.payType?.includes('16') ? 'display' : 'none'}`}
          >
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax.png`} alt="【图片】"></img>payermax
          </div>
          <div
            className={`pay-method-item pay-style-xsolla${this.payItem === 15 ? ' pay-item-check' : ''}`}
            onclick={() => {
              this.onClickPayItem(15);
            }}
            style={`display: ${this.payType?.includes('15') ? 'display' : 'none'}`}
          >
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla.png`} alt="【图片】"></img>xsolla
          </div>
          <div
            className={`pay-method-item pay-style-airwallex${this.payItem === 17 ? ' pay-item-check' : ''}`}
            onclick={() => {
              this.onClickPayItem(17);
            }}
            style={`display: ${this.payType?.includes('17') ? 'display' : 'none'}`}
          >
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex.png`} alt="【图片】"></img>airwallex
          </div>
        </div>
        <div className="pay-order">
          <div className="pay-order-details">
            <div className="details-head">
              <div className="detail-img" style={{ "--charge-name": `"${this.chargeName}"` }}>
                <img src={this.icon}></img>
              </div>
              <div className="commodity-info">
                <div className="info">
                  <span>{app.translator.trans('dl-pay.forum.order.product_information')}:</span> {this.chargeName}
                </div>
                <div className="info">
                  <span>{app.translator.trans('dl-pay.forum.order.product_quantity')}:</span> {this.inputValue}
                </div>
                <div className="info">
                  <span>{app.translator.trans('dl-pay.forum.order.role_information')}:</span>
                  {this.roleInfo}{app.translator.trans('dl-pay.forum.user.srvId_count')}
                </div>
              </div>
            </div>
            <div className="price-box">
              <div className="item">
                <span className="name">{app.translator.trans('dl-pay.forum.order.original_price_of_goods')}:</span>
                <span>USD {this.chargeOriginal}</span>
              </div>
              <div className="item">
                <span className="name">{app.translator.trans('dl-pay.forum.order.mall_discount')}:</span>
                <span className="discount">- USD {this.chargeDiscount}</span>
              </div>
              {/* <div className="item">
                <span className="name">{app.translator.trans('dl-pay.forum.order.coupon')}:</span>
                <span className="discount">- USD 0.99</span>
              </div> */}
            </div>
          </div>
          <div className="price">
            {app.translator.trans('dl-pay.forum.order.all')} <span>USD {this.chargeAmount}</span>
          </div>
          {this.PayBtn()}
        </div>
      </div>
    );
  }
  PayBtn() {
    return (
      <div
        className="pay-btn"
        id="shop-pay-btn"
        onclick={() => {
          this.onClickPayBtn();
        }}
      ></div>
    );
  }
  onClickPayItem(e) {
    this.payItem = e;
    const imgurl12 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal-while.png`;
    const imgurl16 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax-while.png`;
    const imgurl15 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla-while.png`;
    const imgurl17 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex-while.png`;
    let item = document.getElementsByClassName('pay-btn')[0];
    if (this.payItem === 12) {
      item.style.background = `url("${imgurl12}")`;
    } else if (this.payItem === 16) {
      item.style.background = `url("${imgurl16}")`;
    } else if (this.payItem === 15) {
      item.style.background = `url("${imgurl15}")`;
    } else if (this.payItem === 17) {
      item.style.background = `url("${imgurl17}")`;
    }
  }
  onClickPayBtn() {
    if (this.inputValue <= 0) {
      let targetElement = document.getElementById('gift-pack-sum');
      // 使用scrollIntoView方法平滑滚动到目标元素
      targetElement.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    let route = app.route('pay.mallorder', { type: 'postMallOrdered' });
    let redirectUrl = window.location.hostname + route;
    // 拼接透传参数 rid$$platform$$zone_id$$渠道$$礼包id$$购买描述$$包标签$$时间戳
    let rid = app.data['currentRole']['rid'];
    let srvId = app.data['currentRole']['srvId'];
    let pkgId = app.data['currentRole']['pkgId'];
    let srvArr = srvId.split('_');
    let chargeId = this.chargeList[this.giftPackCheck][1];
    let time = Math.floor(new Date().getTime() / 1000);
    let subGameData = `${rid}$$${srvArr[0]}$$${srvArr[1]}$$flarum$$${chargeId}$$${this.chargeName}$$flarum$$${time}`;
    // 支付
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/sdkPay',
        params: {
          money: this.chargeOriginal,
          goodsId: this.chargeName, // 订单备注
          payType: this.payItem,
          subGameData: subGameData,
          redirectUrl: redirectUrl,
          roleId: rid,
          orderType: 0, // 普通充值
          srvId: srvId,
          chargeId: chargeId,
          quantity: this.inputValue,
          pkgId: pkgId,
        },
        errorHandler: this.onerror.bind(this),
      })
      .then((res) => {
        if (res.payUrl) {
          window.location.href = res.payUrl;
        } else {
          // TODO 支付失败弹窗
          console.log('获取支付链接失败' + res);
        }
      });
  }

  onerror(error: RequestError) {
    AlertUtil.onWarn(app, app.translator.trans(error.responseText + ''));
  }
}
